//------------------------------------------------------ externos
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
//------------------------------------------------------ elementos
import Icono from "../components/Icono";
import RegistroAccess from "../components/access/RegistroAccess";
import EmpresasAccess from "../components/access/EmpresasAccess";
import FormMovimientoPorteria from "../components/formularios/events/FormMovimientoPorteria";
import FormPersona from "../components/formularios/FormPersona";
import FormTractor from "../components/formularios/FormTractor";
import FormFurgon from "../components/formularios/FormFurgon";
import FormProveedor from "../components/formularios/FormProveedor";
//------------------------------------------------------ funciones y data
import { ALTAS, CAMINOS, camino } from "../shared/barrera";
import { altaSoloFleterosYExternos } from "../shared/altaPorteria";
import { useRealtime } from "../services/store";
import "./css/Porteria.css";

/* Ingreso y egreso: UNA pregunta en vez de ocho baldosas.
 *
 * El porqué está entero en `shared/barrera.js`. Acá sólo se dibuja, y las dos
 * decisiones que quedan de este lado son:
 *
 *   · las ALTAS arrancan PLEGADAS — no escondidas. Escondidas del todo, el
 *     que tiene adelante un tractor que no está cargado no sabe que se puede
 *     resolver desde acá y termina anotando cualquier cosa en el detalle. Es
 *     la misma regla que el rail: se pliega a mano, nunca se recorta solo;
 *
 *   · el formulario se abre SOBRE la pantalla y al cerrarlo se vuelve a la
 *     pregunta. Sin volver, el que carga veinte movimientos seguidos tendría
 *     que reelegir el camino cada vez — y eligiendo entre cuatro apurado, un
 *     día se elige el que no era.
 */

/* Las claves son las de `ALTAS`, con `alta-` adelante: `proveedor` a secas ya
 * es un camino de la barrera —uno que cruza— y son dos acciones distintas. */
const FORMS_ALTA = {
  "alta-persona": FormPersona,
  "alta-tractor": FormTractor,
  "alta-furgon": FormFurgon,
  "alta-proveedor": FormProveedor,
};

const Porteria = () => {
  console.log("[Render] Seccion Porteria");
  const eventos = useRealtime("eventosPorteria");
  /* La barrera con `cargar.fleteros` (y sin `cargar.gente`) da de alta sólo
   * fleteros y externos: el formulario de persona se abre acotado a eso, que
   * es lo único que la base le va a aceptar. Ver `shared/altaPorteria.js`. */
  const { permisos = null } = useOutletContext() || {};
  const acotado = altaSoloFleterosYExternos(permisos);

  const [abierto, setAbierto] = useState(null);   // id del camino elegido
  const [alta, setAlta] = useState(null);         // id del alta elegida
  const [verAltas, setVerAltas] = useState(false);

  const elegido = camino(abierto);
  const FormAlta = alta ? FORMS_ALTA[alta] : null;

  return (
    <section className="section">
      <div className="barrera">
        <h3 className="barrera__pregunta">¿Qué está cruzando la barrera?</h3>

        <div className="barrera__caminos">
          {CAMINOS.map((c) => (
            <button
              key={c.id}
              type="button"
              className="barrera__camino"
              onClick={() => setAbierto(c.id)}
            >
              <span className="barrera__icono" aria-hidden="true">
                <Icono nombre={c.icono} />
              </span>
              <span className="barrera__txt">
                <span className="barrera__titulo">{c.titulo}</span>
                {/* CUÁNDO SE USA, al lado y no en la cabeza de nadie.
                    «FLETEROS & EXTERNOS» no dice si el camión de un tercero
                    que viene a cargar va ahí o en proveedores, y esa duda se
                    resuelve preguntando o eligiendo mal. */}
                <span className="barrera__cuando">{c.cuando}</span>
              </span>
            </button>
          ))}
        </div>

        {/* ── Lo que ya se cargó ─────────────────────────────────────────
            Va acá abajo y no arriba: la pantalla es para CARGAR, y el
            registro es para consultar. */}
        <div className="barrera__abajo">
          <RegistroAccess
            filtro={"porteria"}
            title={"Registro de portería"}
            data={eventos}
            editable={false}
          />
          <EmpresasAccess col="proveedores" />
        </div>

        {/* ── Las altas ──────────────────────────────────────────────────
            No son un camino de la barrera: son la salida para cuando lo que
            cruzó todavía no existe en el sistema. Plegadas y a la vista. */}
        <div className="barrera__altas">
          <button
            type="button"
            className="barrera__plegar"
            aria-expanded={verAltas}
            onClick={() => setVerAltas((v) => !v)}
          >
            {verAltas ? "▾" : "▸"} ¿Falta algo en el padrón? Darlo de alta
          </button>
          {verAltas && (
            <div className="barrera__altas-lista">
              {ALTAS.map((a) => (
                <button
                  key={a.id}
                  type="button"
                  className="barrera__alta"
                  onClick={() => setAlta(a.id)}
                >
                  <Icono nombre={a.icono} />
                  {a.id === "alta-persona" && acotado
                    ? "Un fletero o un externo"
                    : a.titulo}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* `camino()` devuelve null ante un id desconocido y acá eso no dibuja
          nada, en vez de caer en «tractor de la flota»: cargar el movimiento
          en el formulario equivocado no falla en ningún lado. */}
      {elegido && (
        <FormMovimientoPorteria
          type={elegido.tipo}
          onGuardar={() => setAbierto(null)}
          onClose={() => setAbierto(null)}
          plus={true}
        />
      )}

      {FormAlta && (
        <FormAlta
          onGuardar={() => setAlta(null)}
          onClose={() => setAlta(null)}
          {...(alta === "alta-persona" && acotado
            ? { soloFleterosYExternos: true, subtitle: "Fletero o externo" }
            : {})}
        />
      )}
    </section>
  );
};

export default Porteria;
